import React from 'react';
import { useSelector } from 'react-redux';

import {
  CANCEL_PAUSE_REQUEST_MODAL_STAGES,
  cancelRequestModalStageSelector,
} from 'features/courseResume';
import CancelRequestModalConfirmStage from '../CancelRequestModalConfirmStage';
import CancelRequestModalSuccessStage from '../CancelRequestModalSuccessStage';

function CancelRequestModalStageRenderer() {
  const modalStage = useSelector(cancelRequestModalStageSelector);

  switch (modalStage) {
    case CANCEL_PAUSE_REQUEST_MODAL_STAGES.confirm:
      return <CancelRequestModalConfirmStage />;
    case CANCEL_PAUSE_REQUEST_MODAL_STAGES.success:
      return <CancelRequestModalSuccessStage />;
    default:
      return null;
  }
}

export default CancelRequestModalStageRenderer;
